import { jsx as _jsx } from "react/jsx-runtime";
import { StruggleIcon } from 'shared/assets/icons/struggle';
import { ErrorWidget } from 'shared/components';
/**
 * Default 403 page
 */
var Forbidden = function (props) {
    return (_jsx(ErrorWidget, { title: "You don't have permission to view this client.", text: "Go to My Notes", icon: _jsx(StruggleIcon, {}), url: "/notes/upcoming" }));
};
export default Forbidden;
